import { render, staticRenderFns } from "./trainingModulePageNew3.vue?vue&type=template&id=4804087f&scoped=true&"
import script from "./trainingModulePageNew3.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageNew3.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageNew3.vue?vue&type=style&index=0&id=4804087f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4804087f",
  null
  
)

export default component.exports